<template>
  <div v-if="rows.length">
    <div class="as-shooting__top">
      <TabsBtn
        :tabs="tabs"
        :activeTab="activeTab"
        @change="changeTab"
        :isShowBorder="true"
      />
      <div
        class="as-menu"
        :class="{
          'as-active': isShowFull,
        }"
        @click="isShowFull = !isShowFull"
      >
        <IconMenu />
      </div>
    </div>

    <div
      class="as-shooting"
      :class="{
        [`as-shooting-${gSiteName}`]: true,
        'as-show-full': isShowFull,
        'as-scrolling as-scrolling__have-tab as-scrolling__result-popup':
          isPopup,
      }"
    >
      <div class="as-shooting__table">
        <div class="as-shooting__table-row as-shooting__table-row-head">
          <div
            v-for="column in columns"
            :key="column.name"
            @click="sortData(column.name)"
            :class="[
              `as-shooting__table-column ${column.class}`,
              {
                'as-row-active': sort.column === column.name,
              },
            ]"
            type="button"
          >
            {{ column.title }}

            <IconArrownDown
              v-if="sort.column === column.name"
              class="as-d-inline-flex"
              :class="{
                'as-sort-down': sort.type === 'ASC',
                'as-sort-up': sort.type === 'DESC',
              }"
            />
          </div>
        </div>
        <div
          v-for="(row, keyRow) in rows"
          :key="keyRow"
          class="as-shooting__table-row"
        >
          <div
            class="as-shooting__table-column as-shooting__table-column-player"
          >
            <div class="as-shooting__player">
              <img
                :src="getImgUrlBySport('player', row.id)"
                class="as-shooting__player-logo"
                :alt="row.player_name"
              />
              <div class="as-shooting__player-content">
                <div class="as-shooting__player-name">
                  {{ row.player_name }}
                </div>
                <div class="as-shooting__player-detail">
                  <span class="as-start">{{ row.starter }}</span>
                  <span class="as-position">{{ row?.positionGame || "" }}</span>
                </div>
                <div
                  v-if="activeTab === 'all'"
                  class="as-shooting__player-name"
                >
                  <span v-if="row.teamId === 1" class="as-position">{{
                    props.shooting?.match?.home_team?.name
                  }}</span>
                  <span v-if="row.teamId === 2" class="as-position">{{
                    props.shooting?.match?.away_team?.name
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="as-shooting__table-column as-text-center"
            :class="setAsRowActive('min')"
          >
            {{ getRowdata(row, "min") }}
          </div>
          <div
            class="as-shooting__table-column as-text-center"
            :class="setAsRowActive('pts')"
          >
            {{ getRowdata(row, "pts") }}
          </div>
          <div
            class="as-shooting__table-column as-text-center"
            :class="setAsRowActive('reb')"
          >
            {{ getRowdata(row, "reb") }}
          </div>
          <div
            class="as-shooting__table-column as-text-center"
            :class="setAsRowActive('ast')"
          >
            {{ getRowdata(row, "ast") }}
          </div>
          <div
            class="as-shooting__table-column as-text-center as-coulumn-show-full"
            :class="setAsRowActive('blk')"
          >
            {{ getRowdata(row, "blk") }}
          </div>
          <div
            class="as-shooting__table-column as-text-center as-coulumn-show-full"
            :class="setAsRowActive('stl')"
          >
            {{ getRowdata(row, "stl") }}
          </div>
          <div
            class="as-shooting__table-column as-text-center as-coulumn-show-full"
            :class="setAsRowActive('fg')"
          >
            {{ getRowdata(row, "fg") }}
          </div>
          <div
            class="as-shooting__table-column as-text-center as-coulumn-show-full"
            :class="setAsRowActive('3pt')"
          >
            {{ getRowdata(row, "3pt") }}
          </div>
          <div
            class="as-shooting__table-column as-text-center as-coulumn-show-full"
            :class="setAsRowActive('ft')"
          >
            {{ getRowdata(row, "ft") }}
          </div>
          <div
            class="as-shooting__table-column as-text-center as-coulumn-show-full"
            :class="setAsRowActive('oreb')"
          >
            {{ getRowdata(row, "oreb") }}
          </div>
          <div
            class="as-shooting__table-column as-text-center as-coulumn-show-full"
            :class="setAsRowActive('dreb')"
          >
            {{ getRowdata(row, "dreb") }}
          </div>
          <div
            class="as-shooting__table-column as-text-center as-coulumn-show-full"
            :class="setAsRowActive('tov')"
          >
            {{ getRowdata(row, "tov") }}
          </div>
          <div
            class="as-shooting__table-column as-text-center as-coulumn-show-full"
            :class="setAsRowActive('at')"
          >
            {{ getRowdata(row, "at") }}
          </div>
          <div
            class="as-shooting__table-column as-text-center as-coulumn-show-full"
            :class="setAsRowActive('pf')"
          >
            {{ getRowdata(row, "pf") }}
          </div>
          <div
            class="as-shooting__table-column as-text-center as-coulumn-show-full"
            :class="setAsRowActive('+/-')"
          >
            {{ getRowdata(row, "+/-") }}
          </div>
        </div>
      </div>
    </div>
    <div class="">
      <div class="as-note">
        <div class="as-note-item">
          <span class="as-key">MIN: </span>
          <span class="as-value">Thời gian ra sân</span>
        </div>
        <div class="as-note-item">
          <span class="as-key">PTS: </span>
          <span class="as-value">Điểm</span>
        </div>
        <div class="as-note-item">
          <span class="as-key">REB: </span>
          <span class="as-value">Bắt bóng bật bảng</span>
        </div>
        <div class="as-note-item">
          <span class="as-key">AST: </span>
          <span class="as-value">Đường chuyền kiến tạo</span>
        </div>
        <div class="as-note-item">
          <span class="as-key">BLK: </span>
          <span class="as-value">Chặn bóng</span>
        </div>
        <div class="as-note-item">
          <span class="as-key">STL: </span>
          <span class="as-value">Cướp bóng</span>
        </div>
        <div class="as-note-item">
          <span class="as-key">FG: </span>
          <span class="as-value">Chụp</span>
        </div>
        <div class="as-note-item">
          <span class="as-key">3PT: </span>
          <span class="as-value">Tỷ lệ 3 điểm</span>
        </div>
        <div class="as-note-item">
          <span class="as-key">FT: </span>
          <span class="as-value">Tỉ lệ ném phạt</span>
        </div>
        <div class="as-note-item">
          <span class="as-key">TOV: </span>
          <span class="as-value">Mất bóng</span>
        </div>
        <div class="as-note-item">
          <span class="as-key">OREB: </span>
          <span class="as-value">Bắt bóng bật bảng tấn công</span>
        </div>
        <div class="as-note-item">
          <span class="as-key">DREB: </span>
          <span class="as-value">Bắt bóng bật bảng phòng ngự</span>
        </div>
        <div class="as-note-item">
          <span class="as-key">A/T: </span>
          <span class="as-value">Đường chuyền kiến tạo/Mất bóng</span>
        </div>
        <div class="as-note-item">
          <span class="as-key">PF: </span>
          <span class="as-value">Lỗi cá nhân</span>
        </div>
        <div class="as-note-item">
          <span class="as-key">+/-: </span>
          <span class="as-value">Plus Minus</span>
        </div>
      </div>
    </div>
  </div>
  <NoData v-else />
</template>

<script setup lang="ts">
import { defineProps, ref, computed } from "vue";
import IconArrownDown from "~src/components/icons/IconArrownDown.vue";
import IconMenu from "~src/components/icons/IconMenu.vue";
import NoData from "~src/components/NoData.vue";
import type {
  IMatch,
  IRecent,
  IPlayerDataShooting,
} from "~src/interfaces//basketball";
import { formatLocalTime } from "~src/helpers/CommonHelper";
import { mapPlayer } from "~src/helpers/basketball";
import TabsBtn from "~src/components/TabsBtn.vue";

interface IProps {
  isPopup: boolean;
  shooting: any;
  match: IMatch;
}

const props = withDefaults(defineProps<IProps>(), {
  isPopup: true,
});

const isShowFull = ref(false);
const activeTab = ref("all");
const tabs = ref([
  {
    title: "Tất cả",
    key: "all",
  },
  {
    title: props.shooting?.match?.home_team?.name || "Home Team",
    key: "home",
  },
  {
    title: props.shooting?.match?.away_team?.name || "Away Team",
    key: "away",
  },
]);

const columns = [
  {
    title: "Cầu thủ",
    name: "player_name",
    class: "as-shooting__table-column-player as-column-head",
  },
  {
    title: "MIN",
    name: "min",
    class: "as-text-center",
  },
  {
    title: "PTS",
    name: "pts",
    class: "as-text-center as-c-total",
  },
  {
    title: "REB",
    name: "reb",
    class: "as-text-center as-c-w",
  },
  {
    title: "AST",
    name: "ast",
    class: "as-text-center as-c-d",
  },
  {
    title: "BLK",
    name: "blk",
    class: "as-text-center as-coulumn-show-full",
  },
  {
    title: "STL",
    name: "stl",
    class: "as-text-center as-coulumn-show-full",
  },
  {
    title: "FG",
    name: "fg",
    class: "as-text-center as-coulumn-show-full",
  },
  {
    title: "3PT",
    name: "3pt",
    class: "as-text-center as-coulumn-show-full",
  },
  {
    title: "FT",
    name: "ft",
    class: "as-text-center as-coulumn-show-full",
  },
  {
    title: "OREB",
    name: "oreb",
    class: "as-text-center as-coulumn-show-full",
  },
  {
    title: "DREB",
    name: "dreb",
    class: "as-text-center as-coulumn-show-full",
  },
  {
    title: "TOV",
    name: "tov",
    class: "as-text-center as-coulumn-show-full",
  },
  {
    title: "A/T",
    name: "at",
    class: "as-text-center as-coulumn-show-full",
  },
  {
    title: "PF",
    name: "pf",
    class: "as-text-center as-coulumn-show-full",
  },
  {
    title: "+/-",
    name: "+/-",
    class: "as-text-center as-coulumn-show-full",
  },
];

const sort = ref({
  column: "",
  type: "ASC",
});

const changeTab = (val: string) => {
  activeTab.value = val;
};

const rows = computed(() => {
  let rows = [];

  const lineup = props?.shooting?.lineup;
  const playersHomeTeam = lineup?.players[0] || [];
  const playersAwayTeam = lineup?.players[1] || [];
  const allPlayers = [...playersHomeTeam, ...playersAwayTeam];
  let allPlayersLineup = [];
  if (!lineup) {
    allPlayersLineup = [];
  } else {
    let { home_team_squad, away_team_squad, players } = lineup;
    if (!home_team_squad) {
      home_team_squad = {
        squad: [],
      };
    }

    if (!away_team_squad) {
      away_team_squad = {
        squad: [],
      };
    }
    const allPlayersLineup = [
      ...home_team_squad?.squad,
      ...away_team_squad?.squad,
    ];
  }

  for (const row of allPlayers) {
    const currentPlayerInfo = row[4].split("^");
    const hitsShots = currentPlayerInfo[1].split("-"); // "8-12" -> 8 successful shots
    const threePointers = currentPlayerInfo[2].split("-"); // "2-3" -> 2 successful three-pointers
    const freeThrows = currentPlayerInfo[3].split("-"); // "1-1" -> 1 successful free throw

    // Calculate two-pointers by subtracting three-pointers from total field goals
    const twoPointersMade = hitsShots[0] - threePointers[0];
    const threePointersMade = parseInt(threePointers[0], 10);
    const freeThrowsMade = parseInt(freeThrows[0], 10);

    // Calculate total points
    const totalPoint =
      twoPointersMade * 2 + threePointersMade * 3 + freeThrowsMade * 1;

    const isHome = playersHomeTeam.some((item: any) => item[0] === row[0]);
    rows.push({
      ...row,
      id: row[0],
      positionGame: mapPlayer(row[0], props?.shooting?.listPlayer)?.position
        ?.position,
      player_name: row[1],
      logo: row[2],
      reb: parseInt(currentPlayerInfo[6]) || 0,
      ast: parseInt(currentPlayerInfo[7]) || 0,
      min: parseInt(currentPlayerInfo[0]) || 0,
      blk: parseInt(currentPlayerInfo[9]) || 0,
      stl: parseInt(currentPlayerInfo[8]) || 0,
      fg: currentPlayerInfo[1] || "0-0",
      "3pt": currentPlayerInfo[2] || "0-0",
      starter: parseInt(currentPlayerInfo[16]) === 0 ? "Starter" : "",
      teamId: isHome ? 1 : 2,
      totalPoint,
      oreb: currentPlayerInfo[4],
      dreb: currentPlayerInfo[5],
      tov: currentPlayerInfo[10],
      ft: currentPlayerInfo[3],
      "+/-": currentPlayerInfo[12],
      at:
        currentPlayerInfo[10] > 0
          ? (
              (parseInt(currentPlayerInfo[7]) || 0) / currentPlayerInfo[10]
            ).toFixed(2)
          : 0,
      pf: currentPlayerInfo[11],
    });
  }
  if (rows.length === 0) {
    if (!lineup) {
      return [];
    }
    const { home_team_squad, away_team_squad, players } = lineup;
    const homePlayers = home_team_squad?.squad.map((player: any) => {
      const currentPlayer = allPlayers.find((item) => {
        return item[0] == player?.player?.id;
      });
      const currentPlayerInfo = currentPlayer
        ? currentPlayer[4].split("^")
        : [];
      if (currentPlayer) {
      }
      return {
        id: player?.player?.id,
        positionGame: player?.position,
        teamId: 1,
        player_name:
          player?.player?.name ||
          mapPlayer(player?.player?.id, props?.shooting?.listPlayer)?.name,
        logo: mapPlayer(player?.player?.id, props?.shooting?.listPlayer)?.logo,
        totalPoint: 0,
        reb: parseInt(currentPlayerInfo[6]) || 0,
        ast: parseInt(currentPlayerInfo[7]) || 0,
        min: parseInt(currentPlayerInfo[0]) || 0,
        blk: parseInt(currentPlayerInfo[9]) || 0,
        stl: parseInt(currentPlayerInfo[8]) || 0,
        "3pt": parseInt(currentPlayerInfo[2]?.split("-")?.[0]) || 0,
        starter: parseInt(currentPlayerInfo[16]) === 0 ? "Starter" : "",
        dreb: currentPlayerInfo[5],
        tov: currentPlayerInfo[10],
        ft: currentPlayerInfo[3],
        "+/-": currentPlayerInfo[12],
        at:
          currentPlayerInfo[10] > 0
            ? (
                (parseInt(currentPlayerInfo[7]) || 0) / currentPlayerInfo[10]
              ).toFixed(2)
            : 0,
        pf: currentPlayerInfo[11],
      };
    });
    const awayPlayers = away_team_squad?.squad.map((player: any) => {
      const currentPlayer = allPlayers.find(
        (item) => item[0] === player?.player?.id
      );
      const currentPlayerInfo = currentPlayer
        ? currentPlayer[4].split("^")
        : [];
      return {
        id: player?.player?.id,
        positionGame: player?.position,
        teamId: 2,
        player_name:
          player?.player?.name ||
          mapPlayer(player?.player?.id, props?.shooting?.listPlayer)?.name,
        logo: mapPlayer(player?.player?.id, props?.shooting?.listPlayer)?.logo,
        totalPoint: 0,
        reb: parseInt(currentPlayerInfo[6]) || 0,
        ast: parseInt(currentPlayerInfo[7]) || 0,
        min: parseInt(currentPlayerInfo[0]) || 0,
        blk: parseInt(currentPlayerInfo[9]) || 0,
        stl: parseInt(currentPlayerInfo[8]) || 0,
        "3pt": parseInt(currentPlayerInfo[2]?.split("-")?.[0]) || 0,
        starter: parseInt(currentPlayerInfo[16]) === 0 ? "Starter" : "",
        dreb: currentPlayerInfo[5],
        tov: currentPlayerInfo[10],
        ft: currentPlayerInfo[3],
        "+/-": currentPlayerInfo[12],
        at:
          currentPlayerInfo[10] > 0
            ? (
                (parseInt(currentPlayerInfo[7]) || 0) / currentPlayerInfo[10]
              ).toFixed(2)
            : 0,
        pf: currentPlayerInfo[11],
      };
    });
    rows = [...homePlayers, ...awayPlayers];
  }
  if (activeTab.value === "all") {
    rows = rows.sort((a: any, b: any) => {
      return b.totalPoint > a.totalPoint ? 1 : -1;
    });
    return rows;
  }
  rows = rows
    .filter((row) => {
      if (activeTab.value === "home") {
        return row.teamId === 1;
      } else {
        return row.teamId === 2;
      }
    })
    .map((item, index) => {
      return {
        ...item,
        position: index + 1,
      };
    });
  rows?.sort((a: any, b: any) => {
    if (activeTab.value === "home") {
      // chọn sắp xếp
      if (sort.value.column) {
        // sắp xếp string
        if (sort.value.column === "player_name") {
          if (sort.value.type === "DESC") {
            return a.player_name.localeCompare(b.player_name);
          } else {
            return b.player_name.localeCompare(a.player_name);
          }
        } else if (sort.value.column === "position") {
          if (sort.value.type === "DESC") {
            return a.position - b.position;
          } else {
            return b.position - a.position;
          }
        } else if (sort.value.column === "pts") {
          if (sort.value.type === "DESC") {
            return a.totalPoint - b.totalPoint;
          } else {
            return b.totalPoint - a.totalPoint;
          }
        } else if (sort.value.column === "reb") {
          if (sort.value.type === "DESC") {
            return a.reb - b.reb;
          } else {
            return b.reb - a.reb;
          }
        } else if (sort.value.column === "ast") {
          if (sort.value.type === "DESC") {
            return a.ast - b.ast;
          } else {
            return b.ast - a.ast;
          }
        } else if (sort.value.column === "blk") {
          if (sort.value.type === "DESC") {
            return a.blk - b.blk;
          } else {
            return b.blk - a.blk;
          }
        } else if (sort.value.column === "stl") {
          if (sort.value.type === "DESC") {
            return a.stl - b.stl;
          } else {
            return b.stl - a.stl;
          }
        } else if (sort.value.column === "min") {
          if (sort.value.type === "DESC") {
            return a.min - b.min;
          } else {
            return b.min - a.min;
          }
        } else if (sort.value.column === "fg") {
          if (sort.value.type === "DESC") {
            return a.fg - b.fg;
          } else {
            return b.fg - a.fg;
          }
        } else if (sort.value.column === "3pt") {
          if (sort.value.type === "DESC") {
            return a["3pt"] - b["3pt"];
          } else {
            return b["3pt"] - a["3pt"];
          }
        } else if (sort.value.column === "oreb") {
          if (sort.value.type === "DESC") {
            return a.oreb - b.oreb;
          } else {
            return b.oreb - a.oreb;
          }
        } else if (sort.value.column === "min") {
          if (sort.value.type === "DESC") {
            return a.min - b.min;
          } else {
            return b.min - a.min;
          }
        } else {
          if (sort.value.type === "DESC") {
            return (
              a[`${activeTab.value}_${sort.value.column}`] -
              b[`${activeTab.value}_${sort.value.column}`]
            );
          } else {
            return (
              b[`${activeTab.value}_${sort.value.column}`] -
              a[`${activeTab.value}_${sort.value.column}`]
            );
          }
        }
      } else {
        return a.totalPoint > b.totalPoint ? -1 : 1;
      }
    }

    if (activeTab.value === "away") {
      if (sort.value.column) {
        if (sort.value.column === "player_name") {
          if (sort.value.type === "DESC") {
            return a.player_name.localeCompare(b.player_name);
          } else {
            return b.player_name.localeCompare(a.player_name);
          }
        } else if (sort.value.column === "position") {
          if (sort.value.type === "DESC") {
            return a.position - b.position;
          } else {
            return b.position - a.position;
          }
        } else if (sort.value.column === "pts") {
          if (sort.value.type === "DESC") {
            return a.totalPoint - b.totalPoint;
          } else {
            return b.totalPoint - a.totalPoint;
          }
        } else if (sort.value.column === "reb") {
          if (sort.value.type === "DESC") {
            return a.reb - b.reb;
          } else {
            return b.reb - a.reb;
          }
        } else if (sort.value.column === "ast") {
          if (sort.value.type === "DESC") {
            return a.ast - b.ast;
          } else {
            return b.ast - a.ast;
          }
        } else if (sort.value.column === "blk") {
          if (sort.value.type === "DESC") {
            return a.blk - b.blk;
          } else {
            return b.blk - a.blk;
          }
        } else if (sort.value.column === "stl") {
          if (sort.value.type === "DESC") {
            return a.stl - b.stl;
          } else {
            return b.stl - a.stl;
          }
        } else if (sort.value.column === "fg") {
          if (sort.value.type === "DESC") {
            return a.fg - b.fg;
          } else {
            return b.fg - a.fg;
          }
        } else if (sort.value.column === "3pt") {
          if (sort.value.type === "DESC") {
            return a["3pt"] - b["3pt"];
          } else {
            return b["3pt"] - a["3pt"];
          }
        } else if (sort.value.column === "oreb") {
          if (sort.value.type === "DESC") {
            return a.oreb - b.oreb;
          } else {
            return b.oreb - a.oreb;
          }
        } else {
          if (sort.value.type === "DESC") {
            return (
              a[`${activeTab.value}_${sort.value.column}`] -
              b[`${activeTab.value}_${sort.value.column}`]
            );
          } else {
            return (
              b[`${activeTab.value}_${sort.value.column}`] -
              a[`${activeTab.value}_${sort.value.column}`]
            );
          }
        }
      } else {
        return a.totalPoint > b.totalPoint ? -1 : 1;
      }
    }
  });
  return rows;
});

const sortData = (columnName: string) => {
  let type = "ASC";
  if (sort.value.column === columnName) {
    if (sort.value.type === "ASC") {
      type = "DESC";
    }
  }
  sort.value = {
    column: columnName,
    type: type,
  };
};

const getContrastColor = (hexcolor: string) => {
  // Remove the hash if it's there
  hexcolor = hexcolor.replace("#", "");
  if (hexcolor === "") return "white";

  // Parse r, g, b values
  let r = parseInt(hexcolor.substring(0, 2), 16); // hex to integer
  let g = parseInt(hexcolor.substring(2, 4), 16);
  let b = parseInt(hexcolor.substring(4, 6), 16);

  // Determine the brightness of the background
  let brightness = (r * 299 + g * 587 + b * 114) / 1000;

  // If brightness is under 128, return white, otherwise return black
  return brightness < 128 ? "white" : "black";
};

const getRowdata = (row: IPlayerDataShooting, field: string) => {
  if (field === "pts") {
    return row.totalPoint || 0;
  } else if (field === "reb") {
    return row.reb || 0;
  } else if (field === "ast") {
    return row.ast || 0;
  } else if (field === "min") {
    return row.min || 0;
  } else if (field === "blk") {
    return row.blk || 0;
  } else if (field === "stl") {
    return row.stl || 0;
  } else if (field === "fg") {
    return row.fg || 0;
  } else if (field === "3pt") {
    return row["3pt"] || 0;
  } else if (field === "oreb") {
    return row.oreb || 0;
  } else if (field === "dreb") {
    return row.dreb || 0;
  } else if (field === "ft") {
    return row.ft || 0;
  } else if (field === "tov") {
    return row.tov || 0;
  } else if (field === "at") {
    return row.at || 0;
  } else if (field === "pf") {
    return row.pf || 0;
  } else if (field === "+/-") {
    return row["+/-"] || 0;
  }
};

const getRecentTitle = (recent: IRecent) => {
  return `${recent.home_scores[0]}:${recent.away_scores[0]} (${
    recent.home_team?.name
  } - ${recent.away_team?.name}) ${formatLocalTime(recent.match_time)}`;
};

const getRecent = (row: any) => {
  if (activeTab.value === "all") {
    return row.recent_matches;
  } else {
    return row[`${activeTab.value}_matches`];
  }
};

const setAsRowActive = (column: string = "") => {
  if (sort.value.column === column) {
    return "as-row-active";
  }

  return "";
};
</script>

<script lang="ts">
export default {};
</script>
